import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PermissionService } from '../../core/services/common/permission.service';

@Directive({
  selector: '[appPermission]'
})
export class PermissionDirective implements OnInit {
  @Input() appPermission: string = '';
  @Input() permissionAction: 'read' | 'write' = 'write';
  @Input() permissionBehavior: 'hide' | 'disable' = 'hide';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    const isAdmin = this.permissionService.isAdminRole();

    if (isAdmin) {
      return;
    }

    const hasPermission = this.permissionService.hasPagePermission(
      this.appPermission,
      this.permissionAction
    );

    if (!hasPermission) {
      if (this.permissionBehavior === 'hide') {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      } else if (this.permissionBehavior === 'disable') {
        this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
        this.renderer.addClass(this.el.nativeElement, 'opacity-50');
        this.renderer.addClass(this.el.nativeElement, 'cursor-not-allowed');
      }
    }
  }
}
